import { InvoiceDetailsSettingsFormData } from 'models/forms';

export const emptyInvoiceDetailsSettingsForm = () => {
    return {
        vatNo: '',
        costCenter: '',
        invoiceAddress: {
            street: '',
            postalCode: '',
            city: '',
            country: '',
        },
        email: '',
        phone: '',
        site: '',
        postgiro: '',
        bankgiro: '',
        bicSwift: '',
        iban: '',
        paymentBoxAccount: '',
        accountNumber: '',
        kidEnabled: false,
        kidLength: '',
        kidCheckDigitMethod: '',
        registrationNumber: '',
        fiEnabled: false,
        fiCardType: '',
        fiCreditorNumber: '',
        referenceFormat: '',
        latePaymentInterest: '',
        complaintPeriodDays: '',
        taxNumber: '',
        registeredOffice: '',
        registerCourt: '',
        registerNumber: '',
        managingDirectors: '',
        smallBusinessExemption: false,
        showForetaksregisteret: false,
        invoiceType: '',
        invoiceDelivery: '',
        invoicePeriod: '',
        paymentTerms: 30,
    } as InvoiceDetailsSettingsFormData;
};
